import React from "react";
import { Hub } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "app/store";
import { useGetAdminPermissionsQuery } from "./endpoints";

/**
 * Hook for handling amplify auth events
 */
export const useOnAuthHandler = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const authListener = (data: any) => {
      if (data.payload.event === "customOAuthState") {
        navigate(data.payload.data, { replace: true });
      }
    };

    Hub.listen("auth", authListener);

    return () => Hub.remove("auth", authListener);
  }, [navigate]);
};

const useAdminPermissions = () => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  return useGetAdminPermissionsQuery(undefined, { skip: !isAuthenticated });
};

export const useSuperAdminCheck = () => {
  const { data } = useAdminPermissions();
  return data?.superAdmin ?? false;
};

export const useJeAccrualAdminCheck = () => {
  const { data } = useAdminPermissions();
  return data?.jeAccrualAdmin ?? false;
};

export const useSysAdminCheck = () => {
  const { data } = useAdminPermissions();
  return data?.sysAdmin ?? false;
};
